import {Injectable} from '@angular/core';
import {Newable, PersistenceService} from '../../persistence.service';
import {Patient} from '../../../models/patient.model';
import {ObjectUnsubscribedError, Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Measurement} from '../../../models/measurement.model';
import {DataObject} from '../../../models/data-object.model';

@Injectable({
    providedIn: 'root'
})
export class SapService implements PersistenceService {

    // TODO: test if working
    private baseURL: string;
    private header: any;

    constructor(private http: HttpClient) {
        this.baseURL = 'api/sap/';
        this.header = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic RVhUX1JJU0M6cmlzYy1taQ==',
                'Access-Control-Allow-Origin': '*'
            })
        };
    }

    saveMeasurement(measurement: Measurement) {
        const url = this.baseURL + 'zsense_pat_info';
        const body = JSON.stringify(measurement);
        this.http.post(url, body, {headers: this.header.headers, responseType: 'text'}).subscribe((res) => {
            console.log(res);
        });
    }

    create(data: DataObject): Observable<void> {
        return undefined;
    }

    delete(id: string, type: Newable<DataObject>): Observable<any> {
        return undefined;
    }

    get<T extends DataObject>(id: string, type: Newable<T>): Observable<T> {
        const url = this.baseURL + 'zsense_pat_info?pat_id=' + id;
        return this.http.get(url, this.header).pipe(
            map((obj: any) => {
                return new type().fromJSON(this.lower(obj)) as T;
            })
        );
    }

    list<T extends DataObject>(type: Newable<T>): Observable<T[]> {
        return undefined;
    }

    update(data: DataObject): Observable<any> {
        return undefined;
    }

    private lower(obj): Patient {
        let key;
        const keys = Object.keys(obj);
        let n = keys.length;
        const newobj = {};
        while (n--) {
            key = keys[n];
            newobj[key.toLowerCase()] = obj[key];
        }
        return newobj as Patient;
    }
}
